import DataTable from "@shared/ui/data-table/DataTable";
import SearchTable from "@shared/ui/search-table/SearchTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledBanks } from "./Banks.styled";
import { SEARCH_TABLE_STYLE } from "./banks.constants";
import { useBankOptions } from "./banks.data";
import { useBankStructures } from "./useBankStructures";
import { useBanksBrowse } from "./useBanksBrowse";
import { useBanksNavigation } from "./useBanksNavigation";

function Banks() {
  const theme = useTheme();
  const { searchStructure, tableStructure } = useBankStructures();
  const browse = useBanksBrowse();
  const navigation = useBanksNavigation();
  const bankOptions = useBankOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledBanks>
      {searchStructure ? (
        <SearchTable
          structure={searchStructure}
          useForm={browse.accountSearchForm}
          setStructure={navigation.editSearchStructure}
          reset={browse.reset}
          style={SEARCH_TABLE_STYLE}
        />
      ) : (
        <Skeleton variant="rectangular" height={100} animation="wave" sx={skeletonSx} />
      )}
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={bankOptions}
          selectRow={navigation.selectRow}
          onSelectRow={navigation.rowChosen}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledBanks>
  );
}

export default Banks;
